import api from "./axios";

export const loginUser = async ({ email, password }) => {
  const response = await api.post("/auth/admin/login", { email, password });
  return response.data;
};

export const changePassword = async ({ currentPassword, newPassword }) => {
  const response = await api.post("/auth/change-password", {
    currentPassword,
    newPassword,
  });
  return response.data;
};